export default `
    <span class="label-label-container #= data.containerClasses || ""# #=data.bsc||""#" 
        # if (data.containerBind) { #
             data-bind="#=data.containerBind#" 
        # } #
    >
        <span
             data-label-for-id="#= data.id #" 
             class="bind-label #: data.classes || "" #"
             data-bind="#= data.bindLabel #">
        </span>
        <span
             id="#= data.id || "" #"
             class="bind-value label-label-value #: data.valueClasses || "" #"
            # if (data.bindValue) { # data-bind="#= data.bindValue #" # } #
            # if (data.toolTip) { # title="#= data.toolTip #" # } #>
        </span>
        # if (data.suffix) { #
            <span
                  data-label-for-id="#= data.id #" class="bind-label suffix-label #: data.suffixClasses || "" #"
                 data-bind="#= data.suffix #">
            </span>
        # } #
        # if (data.infoTooltip || data.infoTooltipContent) { #
            <span id="#= data.id #_info" class="pane-field-info"></span>
        # } #
    </span>
`;
